import { render, staticRenderFns } from "./CustomerAccountManagers.vue?vue&type=template&id=68cef324&"
import script from "./CustomerAccountManagers.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports